var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencilInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#CCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pencil-in-circle_svg__clip0_6780_22030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.543 13.726l.2-.2c.702-.701 1.904-.701 2.606 0 .701.702.701 1.904 0 2.605l-.2.2c.8.903.8 2.306-.101 3.107L20.315 35.271c-.1.1-.2.2-.4.2l-6.013 1.504c-.401.1-.802-.1-.902-.601v-.401l1.503-6.113c0-.1.1-.3.2-.4l14.731-14.731c-.3-.2-.701-.2-1.002.1l-5.01 5.01c-.3.3-.802.3-1.103 0-.3-.3-.3-.801 0-1.102l5.01-5.01a2.438 2.438 0 013.207 0c.902-.802 2.205-.802 3.007 0zm-.902 1.103c-.3-.3-.802-.3-1.102 0L15.906 30.46l-1.203 4.71 4.71-1.202 15.633-15.633c.3-.3.3-.802 0-1.102l-2.405-2.405z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pencil-in-circle_svg__clip0_6780_22030"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13 13)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconPencilInCircle;